import Axios from "../utils/axiosInterceptor";
import { RECONCILIATION_APIS } from "../utils/constants";

export type ReconBillUploadListPayload = {
  hospitalId: number;
  schemeId?: number;
  g7CrNo: string;
  billMappingId?: number;
  visitType?: string;
  caseId?: number;
  visitId?: number;
};

export type DsAiRead = {
  patientName?: string;
  uhid?: string;
  doa?: string;
  dod?: string;
  aiReadStatus?: string;
};

export type ReconBillUploadLinkPayload = {
  hospitalId: number;
  documentId: string;
  reconIds: number[];
};

export type ReconBillUploadUnlinkPayload = {
  hospitalId: number;
  reconIds: number[];
};

export type ReconBillUploadCancelPayload = {
  hospitalId: number;
  reconId: number;
  cancelledReason: string;
};

export const getReconBillUploadList = async (
  payload: ReconBillUploadListPayload,
) => {
  const res = await Axios.post(RECONCILIATION_APIS.BILL_UPLOAD_LIST, payload);
  return res.data;
};

export const linkReconBillDocument = async (
  payload: ReconBillUploadLinkPayload,
) => {
  const res = await Axios.post(
    RECONCILIATION_APIS.BILL_UPLOAD_LINK_DOCUMENT,
    payload,
  );
  return res.data;
};

export const unlinkReconBillDocument = async (
  payload: ReconBillUploadUnlinkPayload,
) => {
  const res = await Axios.post(
    RECONCILIATION_APIS.BILL_UPLOAD_UNLINK_DOCUMENT,
    payload,
  );
  return res.data;
};

export const cancelReconBill = async (
  payload: ReconBillUploadCancelPayload,
) => {
  const res = await Axios.post(RECONCILIATION_APIS.BILL_UPLOAD_CANCEL, payload);
  return res.data;
};
